import { jsx, Fragment } from 'react/jsx-runtime';
import { Tooltip as Tooltip$1 } from '@mui/material';

const Tooltip = ({ visible = true, title, children }) => {
    if (visible) {
        return (jsx(Tooltip$1, Object.assign({ title: title, followCursor: true }, { children: children })));
    }
    return jsx(Fragment, { children: children });
};

export { Tooltip };
